const AnalysisIcon: React.FC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.1401 13.2601L19.0801 7.33008L20.2101 8.45008L21.2101 7.45008L19.0801 5.33008L13.1401 11.2601L11.1401 9.26008L2.08008 18.3301L3.08008 19.3301L11.1401 11.2601L13.1401 13.2601Z"
            fill="#C9F1AD"
        />
        <path
            d="M11.1401 13.5101L13.1401 15.5101L20.2101 8.45008L19.0801 7.33008L13.1401 13.2601L11.1401 11.2601L3.08008 19.3301L4.21008 20.4501L11.1401 13.5101Z"
            fill="#A7CE89"
        />
        <path d="M22.9202 3.60986L14.4302 6.43986L20.0902 12.0999L22.9202 3.60986Z" fill="#C9F1AD" />
        <path d="M20.0902 12.0999L17.2002 9.20986L22.9202 3.60986L20.0902 12.0999Z" fill="#A7CE89" />
        <path
            d="M4 21H22C22 20.45 21.55 20 21 20H5C4.45 20 4 19.55 4 19V3C4 2.45 3.55 2 3 2V20C3 20.55 3.45 21 4 21Z"
            fill="#575757"
        />
        <path
            d="M4.00002 20.9999C3.68002 20.9999 3.41002 20.8399 3.23002 20.6099L2.52002 21.3199C2.89002 21.7299 3.41002 21.9899 4.01002 21.9899H21.01C21.56 21.9899 22.01 21.5399 22.01 20.9899H4.00002V20.9999Z"
            fill="#3A3A3A"
        />
        <path
            d="M3 20V2C2.45 2 2 2.45 2 3V20C2 20.51 2.2 20.97 2.51 21.33L3.22 20.62C3.08 20.45 2.99 20.24 2.99 20.01L3 20Z"
            fill="#777777"
        />
    </svg>
)

AnalysisIcon.displayName = 'AnalysisIcon'

export default AnalysisIcon
